let fallbackBaseURL: string | undefined;

// Include using any externally defined baseURL value as a fallback,
// mostly for unit testing. Please avoid using this unless necessary
// (usually it's not as the browser will use the page's base element).
export function getBaseExclaimUrl(): string | undefined {
    const baseEls = document?.getElementsByTagName("base");
    return baseEls?.[0]?.getAttribute("href") ?? fallbackBaseURL;
}

// This is used in the unit tests
export function setBaseUrlForUnitTesting(url: string | undefined): void {
    fallbackBaseURL = url;
}
